<template>
	<section class="view-onboarding-tv" id="view-onboarding-tv">
		<section class="graphic">
			<slot name="graphic:before"></slot>
			<img src="@/Asset/image/onboarding/onboarding-graphic-02.avif" alt="Onboarding Graphic" />
			<slot name="graphic:after"></slot>
		</section>

		<section class="content">
			<h2 class="title">Watch while you wait</h2>
			<p class="large description">
				Stream exciting matches while
				<br />
				you wait for your turn to play
			</p>
		</section>

		<section class="actions">
			<ViewUiButtonContinue v-on:continue="$emit('continue')" />
		</section>
	</section>
</template>

<script lang="ts">
	import * as Service from '@/App/Service';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Onboarding
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewOnboardingTv extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-onboarding-tv {
		background-image: url('@/Asset/image/onboarding/onboarding-background-02.avif');
	}
</style>
